import { render } from "./CoursesPage.vue?vue&type=template&id=a391f89a&scoped=true"
import script from "./CoursesPage.vue?vue&type=script&lang=js"
export * from "./CoursesPage.vue?vue&type=script&lang=js"

import "./CoursesPage.vue?vue&type=style&index=0&id=a391f89a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a391f89a"]])

export default __exports__